import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VList } from 'vuetify/lib/components/VList';
import { VListTile } from 'vuetify/lib/components/VList';
import { VListTileAvatar } from 'vuetify/lib/components/VList';
import { VListTileTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: _vm.$x["payment-wrapper"],
      attrs: { id: "paymentWrapper", "data-app": "" },
      on: {
        click: function ($event) {
          _vm.totalClicks++
        },
      },
    },
    [
      _c("link", {
        attrs: {
          href: "https://fonts.googleapis.com/icon?family=Material+Icons",
          rel: "stylesheet",
        },
      }),
      _vm._v(" "),
      _c(
        "section",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.showAddNewPayment && !_vm.showEditPayment,
              expression: "!showAddNewPayment && !showEditPayment",
            },
          ],
        },
        [
          _c("ns-alert", {
            class: _vm.$x["alert-payments"],
            attrs: {
              type: "card",
              context: "error",
              title: _vm.t.serverErrorTitle,
              visible: _vm.showPaymentsAlert,
            },
            scopedSlots: _vm._u([
              {
                key: "body",
                fn: function () {
                  return [
                    _c("span", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.sanitizeHTML(_vm.t.serverErrorMessage)
                        ),
                      },
                    }),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
          _vm._v(" "),
          _c(
            "div",
            { class: _vm.$x["choose-payment-icon"] },
            [
              _c(
                "h2",
                {
                  staticClass: "subtitle-medium-semibold",
                  class: _vm.$x["add-payment-title"],
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.t.addNewPaymentSectionTitle) +
                      "\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "p",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.t.choosePaymentType,
                      expression: "t.choosePaymentType",
                    },
                  ],
                },
                [_vm._v(_vm._s(_vm.t.choosePaymentType))]
              ),
              _vm._v(" "),
              _vm._l(_vm.groupedCreditTypes, function (c) {
                return _c("span", { key: c.id }, [
                  _c("img", {
                    class: _vm.$x["p-icon"],
                    attrs: { src: _vm.getCardIcon(c.id), name: c.ofsId },
                    on: {
                      click: function ($event) {
                        return _vm.openAddPaymentAndSetPaymentType(0)
                      },
                    },
                  }),
                ])
              }),
              _vm._v(" "),
              _vm._l(_vm.availableSimvTypes, function (c) {
                return _c("span", { key: c.id }, [
                  _c("img", {
                    class: _vm.$x["p-icon"],
                    attrs: { src: _vm.getCardIcon(c.id), name: c.ofsId },
                    on: {
                      click: function ($event) {
                        return _vm.openAddPaymentAndSetPaymentType(c.id)
                      },
                    },
                  }),
                ])
              }),
              _vm._v(" "),
              _vm._l(_vm.availableCarteBleueTypes, function (c) {
                return _c("span", { key: c.id }, [
                  _c("img", {
                    class: _vm.$x["p-icon"],
                    attrs: { src: _vm.getCardIcon(c.id), name: c.ofsId },
                    on: {
                      click: function ($event) {
                        return _vm.openAddPaymentAndSetPaymentType(c.id)
                      },
                    },
                  }),
                ])
              }),
              _vm._v(" "),
              _vm._l(_vm.availablePaymentTypes, function (p) {
                return _c("span", { key: p.id }, [
                  _c("img", {
                    class: [
                      _vm.$x["p-icon"],
                      {
                        "disabled-icon":
                          p.formName === "emptyPayment" &&
                          !_vm.saveNonCreditCards,
                      },
                    ],
                    attrs: { src: _vm.getCardIcon(p.id), name: p.ofsId },
                    on: {
                      click: function ($event) {
                        return _vm.openAddPaymentAndSetPaymentType(p.id)
                      },
                    },
                  }),
                ])
              }),
            ],
            2
          ),
          _vm._v(" "),
          _c("div", { class: _vm.$x["saved-payments-header"] }, [
            _c("h2", { staticClass: "title-small-bold" }, [
              _c("span", [_vm._v(_vm._s(_vm.t.savedPaymentMethods))]),
            ]),
            _vm._v(" "),
            _c(
              "h3",
              {
                class: [
                  _vm.$x["add-payment"],
                  _vm.canAddPayment() ? _vm.$x.lnk : _vm.$x["no-lnk"],
                ],
                on: {
                  click: function ($event) {
                    return _vm.openAddPayment("addPaymentLink")
                  },
                },
              },
              [
                _c("ns-icon", {
                  attrs: { "icon-name": "icon-add", size: "icon-lg" },
                }),
                _vm._v(" " + _vm._s(_vm.t.add) + "\n      "),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _vm.payments.length === 0
            ? _c("div", [_vm._v(_vm._s(_vm.t.noSavedPayments))])
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.payments, function (p) {
            return _c(
              "div",
              { key: p.bePaymentTypeId, class: _vm.$x["saved-payment"] },
              [
                _c("div", [
                  _c("h3", { attrs: { name: "paymentName" } }, [
                    _vm._v(_vm._s(p.paymentName)),
                  ]),
                  _vm._v(" "),
                  _c("div", { class: _vm.$x["cc-info"] }, [
                    _c("img", {
                      class: _vm.$x["p-icon"],
                      attrs: { src: _vm.getCardIcon(p.paymentTypeId) },
                    }),
                    _vm._v(" "),
                    _vm.paymentTypeFormName(p.paymentTypeId) !== "emptyPayment"
                      ? _c("span", { attrs: { name: "paymentNumber" } }, [
                          _vm._v(
                            _vm._s(p.paymentTypeDescription) +
                              " " +
                              _vm._s(_vm.t.endingIn) +
                              " " +
                              _vm._s(_vm.getCcLastFour(p.paymentNumber))
                          ),
                        ])
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  p.expiring
                    ? _c(
                        "div",
                        {
                          class: _vm.$x["cc-expiring"],
                          attrs: { name: "expiration" },
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.t.expiring) + " " + _vm._s(p.expiring)
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  p.expired
                    ? _c(
                        "div",
                        {
                          class: _vm.$x["cc-expired"],
                          attrs: { name: "expired" },
                        },
                        [
                          !p.editExpirationDate
                            ? _c(
                                "div",
                                [
                                  _c("ns-icon", {
                                    staticStyle: {
                                      width: "20px",
                                      height: "20px",
                                      display: "inline-block",
                                      "margin-right": "5px",
                                      "vertical-align": "bottom",
                                    },
                                    attrs: { "icon-name": "icon-error-lg" },
                                  }),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.t.expired) +
                                        " " +
                                        _vm._s(p.expired) +
                                        " "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      class: [
                                        _vm.$x["update-expired-date"],
                                        _vm.$x.lnk,
                                      ],
                                      on: {
                                        click: function ($event) {
                                          return _vm.toggleExpirationDateForm(p)
                                        },
                                      },
                                    },
                                    [_vm._v(_vm._s(_vm.t.update))]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  p.defaultPayment
                    ? _c(
                        "div",
                        {
                          class: _vm.$x["cc-default"],
                          attrs: { name: "defaultPmt" },
                        },
                        [
                          _c("ns-icon", {
                            staticStyle: {
                              width: "20px",
                              height: "20px",
                              display: "inline-block",
                              "margin-right": "5px",
                            },
                            attrs: { "icon-name": "icon-checkmark" },
                          }),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(_vm.t.defaultPayment))]),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  p.editExpirationDate
                    ? _c(
                        "div",
                        { class: _vm.$x["expiration-date-form-wrapper"] },
                        [
                          _c("ns-expire-date-form", {
                            class: _vm.$x["expirationDateForm"],
                            attrs: { translations: _vm.t },
                            on: {
                              input: function ($event) {
                                return _vm.updateExpirationDate(p, $event)
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              class: _vm.$x["close-expiration-form"],
                              attrs: { name: "closeExpirationForm" },
                              on: {
                                click: function ($event) {
                                  return _vm.toggleExpirationDateForm(p)
                                },
                              },
                            },
                            [
                              _c("ns-icon", {
                                staticStyle: {
                                  width: "20px",
                                  height: "20px",
                                  display: "inline-block",
                                  "margin-right": "5px",
                                  "vertical-align": "bottom",
                                },
                                attrs: { "icon-name": "icon-close" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.paymentTypeFormName(p.paymentTypeId) === "emptyPayment"
                    ? _c("div", [
                        _c("p", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.sanitizeHTML(p.paymentMethodText)
                            ),
                          },
                        }),
                      ])
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _c(
                      VMenu,
                      {
                        attrs: {
                          left: "",
                          light: "",
                          "content-class": "pop-menu",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "activator",
                              fn: function (ref) {
                                var on = ref.on
                                return [
                                  _c(
                                    "button",
                                    _vm._g(
                                      {
                                        class: _vm.$x["action-button"],
                                        attrs: { name: "editMenu" },
                                        on: {
                                          click: function ($event) {
                                            _vm.totalClicks++
                                          },
                                        },
                                      },
                                      on
                                    ),
                                    [
                                      _c("ns-icon", {
                                        attrs: {
                                          "icon-name": "icon-menu-dots",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      },
                      [
                        _vm._v(" "),
                        _c(
                          VList,
                          [
                            p.canEdit == true
                              ? _c(
                                  VListTile,
                                  {
                                    attrs: { name: "editPayment" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.openEditPayment(p)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      VListTileAvatar,
                                      [
                                        _c("ns-icon", {
                                          attrs: { "icon-name": "icon-edit" },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(VListTileTitle, [
                                      _vm._v(_vm._s(_vm.t.edit)),
                                    ]),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              VListTile,
                              {
                                attrs: { name: "deletePayment" },
                                on: {
                                  click: function ($event) {
                                    return _vm.openDeleteConfirmation(
                                      p.bePaymentTypeId
                                    )
                                  },
                                },
                              },
                              [
                                _c(
                                  VListTileAvatar,
                                  [
                                    _c("ns-icon", {
                                      attrs: { "icon-name": "icon-trashcan" },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(VListTileTitle, [
                                  _vm._v(_vm._s(_vm.t.delete)),
                                ]),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              VListTile,
                              {
                                attrs: { name: "updateDefault" },
                                on: {
                                  click: function ($event) {
                                    return _vm.doUpdateDefaultPayment(p)
                                  },
                                },
                              },
                              [
                                _c(
                                  VListTileAvatar,
                                  [
                                    _c("ns-icon", {
                                      attrs: { "icon-name": "icon-checkmark" },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(VListTileTitle, [
                                  _vm._v(_vm._s(_vm.t.setAsDefault)),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            )
          }),
          _vm._v(" "),
          _c("div", { class: [_vm.$x["add-payment"], _vm.$x.btn] }, [
            _c(
              "button",
              {
                staticClass: "hit-outline fluid",
                attrs: { disabled: !_vm.canAddPayment() },
                on: {
                  click: function ($event) {
                    return _vm.openAddPayment("addPaymentButton")
                  },
                },
              },
              [_vm._v("+ " + _vm._s(_vm.t.addNewPaymentMethod))]
            ),
          ]),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "section",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showEditPayment,
              expression: "showEditPayment",
            },
          ],
          attrs: { id: "editPaymentSection" },
        },
        [
          _c("ns-alert", {
            class: _vm.$x.alert,
            attrs: {
              type: "card",
              context: "error",
              title: _vm.t.serverErrorTitle,
              visible: _vm.showAddPaymentAlert,
            },
            scopedSlots: _vm._u([
              {
                key: "body",
                fn: function () {
                  return [
                    _c("span", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.sanitizeHTML(_vm.t.serverErrorMessage)
                        ),
                      },
                    }),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
          _vm._v(" "),
          _c(
            "h2",
            {
              staticClass: "subtitle-medium-semibold",
              class: _vm.$x["edit-payment-title"],
            },
            [
              _c("span", [_vm._v(_vm._s(_vm.t.editPaymentSectionTitle))]),
              _vm._v(" "),
              _c(
                "button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.cleanupAddEditPayment()
                    },
                  },
                },
                [_c("ns-icon", { attrs: { "icon-name": "icon-close-x" } })],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _vm.isCreditCardPaymentType(_vm.selectedPaymentType)
            ? _c("ns-credit-card-form", {
                ref: "editCreditCardForm",
                class: _vm.$x["credit-card-form"],
                staticStyle: { "max-width": "500px" },
                attrs: {
                  "edit-mode": "",
                  translations: _vm.t,
                  "available-payments": _vm.formCreditTypes,
                  "prevent-jcb-bin": true,
                },
                model: {
                  value: _vm.currentEditedPayment,
                  callback: function ($$v) {
                    _vm.currentEditedPayment = $$v
                  },
                  expression: "currentEditedPayment",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.withAddress
            ? _c(
                "div",
                { class: _vm.$x["border-top"] },
                [
                  _c("ns-address-form", {
                    ref: "editAddressForm",
                    attrs: {
                      lang: _vm.language,
                      translations: _vm.t.address,
                      editing: _vm.editingBillingAddress,
                    },
                    on: {
                      editing: _vm.setEditingBillingAddress,
                      "address-valid": _vm.setAddressFormValid,
                    },
                    model: {
                      value: _vm.addressFormData,
                      callback: function ($$v) {
                        _vm.addressFormData = $$v
                      },
                      expression: "addressFormData",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.editingBillingAddress,
                  expression: "!editingBillingAddress",
                },
              ],
            },
            [
              _c(
                "div",
                { class: _vm.$x["border-top"] },
                [
                  _c(
                    VForm,
                    { ref: "editPaymentCheckboxForm" },
                    [
                      _c(
                        VCheckbox,
                        {
                          attrs: {
                            disabled: "",
                            checked: "",
                            color: "#7123D9",
                          },
                          model: {
                            value: _vm.agreeToSave,
                            callback: function ($$v) {
                              _vm.agreeToSave = $$v
                            },
                            expression: "agreeToSave",
                          },
                        },
                        [
                          _c("template", { slot: "label" }, [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.t.agreeToSavePaymentType) +
                                "\n              "
                            ),
                          ]),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      !_vm.hideDefaultCheckbox()
                        ? _c(
                            VCheckbox,
                            {
                              attrs: { color: "#7123D9" },
                              model: {
                                value: _vm.setAsDefault,
                                callback: function ($$v) {
                                  _vm.setAsDefault = $$v
                                },
                                expression: "setAsDefault",
                              },
                            },
                            [
                              _c("template", { slot: "label" }, [
                                _vm._v(_vm._s(_vm.t.setAsDefault)),
                              ]),
                            ],
                            2
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.enableStoredCredentials
                    ? _c("p", { class: [_vm.$x["tac"], _vm.$x["message"]] }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.t.agreeToTermsOfUseMessage) +
                            " "
                        ),
                        _c(
                          "a",
                          {
                            class: [_vm.$x.lnk],
                            attrs: {
                              href: _vm.termsOfUseLnk,
                              target: "_blank",
                            },
                          },
                          [_vm._v(_vm._s(_vm.t.termsOfUse))]
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "alert-ghost",
                      attrs: { type: "button", name: "openDeleteConfirmation" },
                      on: {
                        click: function ($event) {
                          return _vm.openDeleteConfirmation(
                            _vm.currentEditedPayment.bePaymentTypeId
                          )
                        },
                      },
                    },
                    [
                      _c("ns-icon", {
                        attrs: { "icon-name": "icon-trashcan" },
                      }),
                      _vm._v(_vm._s(_vm.t.deletePaymentMethod)),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { class: _vm.$x["border-top"] },
                [
                  _c("ns-alert", {
                    class: [_vm.$x.alert, _vm.$x.mobile],
                    attrs: {
                      type: "card",
                      context: "error",
                      title: _vm.t.serverErrorTitle,
                      visible: _vm.showAddPaymentAlert,
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "body",
                        fn: function () {
                          return [
                            _c("span", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.sanitizeHTML(_vm.t.serverErrorMessage)
                                ),
                              },
                            }),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "hit-solid fluid form-save",
                      attrs: { name: "saveEditPayment" },
                      on: {
                        click: function ($event) {
                          return _vm.doSavePayment(_vm.currentEditedPayment)
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.t.save))]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "hit-outline fluid",
                      attrs: { name: "cancelEditPayment" },
                      on: {
                        click: function ($event) {
                          return _vm.cleanupAddEditPayment()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.t.cancel))]
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "section",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showAddNewPayment && !_vm.showEditPayment,
              expression: "showAddNewPayment && !showEditPayment",
            },
          ],
          attrs: { id: "addPaymentSection" },
        },
        [
          _c("ns-alert", {
            class: _vm.$x.alert,
            attrs: {
              type: "card",
              context: "error",
              title: _vm.t.serverErrorTitle,
              visible: _vm.showAddPaymentAlert,
            },
            scopedSlots: _vm._u([
              {
                key: "body",
                fn: function () {
                  return [
                    _c("span", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.sanitizeHTML(_vm.t.serverErrorMessage)
                        ),
                      },
                    }),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
          _vm._v(" "),
          _c("div", { class: _vm.$x.contents }, [
            _c(
              "div",
              { class: _vm.$x.left },
              [
                _c(
                  "h2",
                  {
                    staticClass: "subtitle-medium-semibold",
                    class: _vm.$x["add-payment-title"],
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.t.addNewPaymentSectionTitle) +
                        "\n        "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  VRadioGroup,
                  {
                    model: {
                      value: _vm.selectedPaymentType,
                      callback: function ($$v) {
                        _vm.selectedPaymentType = $$v
                      },
                      expression: "selectedPaymentType",
                    },
                  },
                  [
                    _vm.groupedCreditTypes.length > 0
                      ? _c(
                          "div",
                          { staticClass: "radio-option" },
                          [
                            _c(VRadio, {
                              staticClass: "subtitle-small-semibold",
                              attrs: {
                                name: "payment-type-cc",
                                value: 0,
                                color: "#7123D9",
                              },
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "label" }, [
                              _vm._v(_vm._s(_vm.t.creditOption)),
                            ]),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.groupedCreditTypes.length > 0
                      ? _c(
                          "div",
                          { class: _vm.$x["card-icons"] },
                          _vm._l(_vm.groupedCreditTypes, function (c) {
                            return _c("img", {
                              key: c.id,
                              class: _vm.$x["p-icon"],
                              attrs: { src: _vm.getCardIcon(c.id) },
                              on: {
                                click: function ($event) {
                                  _vm.selectedPaymentType = 0
                                },
                              },
                            })
                          }),
                          0
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(_vm.availableSimvTypes, function (p) {
                      return _c("div", { key: p.id }, [
                        _c(
                          "div",
                          { staticClass: "radio-option" },
                          [
                            _c(VRadio, {
                              attrs: {
                                value: p.id,
                                name: "payment-type-" + p.id,
                                color: "#7123D9",
                                disabled:
                                  p.formName === "emptyPayment" &&
                                  !_vm.saveNonCreditCards,
                              },
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "label" }, [
                              _vm._v(_vm._s(p.localizedName)),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { class: _vm.$x["card-icons"] }, [
                          _c("img", {
                            class: _vm.$x["p-icon"],
                            attrs: { src: _vm.getCardIcon(p.id) },
                            on: {
                              click: function ($event) {
                                _vm.selectedPaymentType = p.id
                              },
                            },
                          }),
                        ]),
                      ])
                    }),
                    _vm._v(" "),
                    _vm._l(_vm.availableCarteBleueTypes, function (p) {
                      return _c("div", { key: p.id }, [
                        _c(
                          "div",
                          {
                            staticClass: "radio-option",
                            on: {
                              click: function ($event) {
                                _vm.selectedPaymentType = p.id
                              },
                            },
                          },
                          [
                            _c(VRadio, {
                              attrs: {
                                value: p.id,
                                name: "payment-type-" + p.id,
                                color: "#7123D9",
                              },
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "label" }, [
                              _vm._v(_vm._s(p.localizedName)),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { class: _vm.$x["card-icons"] }, [
                          _c("img", {
                            class: _vm.$x["p-icon"],
                            attrs: { src: _vm.getCardIcon(p.id) },
                            on: {
                              click: function ($event) {
                                _vm.selectedPaymentType = p.id
                              },
                            },
                          }),
                        ]),
                      ])
                    }),
                    _vm._v(" "),
                    _vm._l(_vm.availablePaymentTypes, function (p) {
                      return _c("div", { key: p.id }, [
                        _c(
                          "div",
                          { staticClass: "radio-option" },
                          [
                            _c(VRadio, {
                              attrs: {
                                value: p.id,
                                name: "payment-type-" + p.id,
                                color: "#7123D9",
                                disabled:
                                  p.formName === "emptyPayment" &&
                                  !_vm.saveNonCreditCards,
                              },
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "label" }, [
                              _vm._v(_vm._s(p.localizedName)),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { class: _vm.$x["card-icons"] }, [
                          _c("img", {
                            class: _vm.$x["p-icon"],
                            attrs: { src: _vm.getCardIcon(p.id) },
                            on: {
                              click: function ($event) {
                                _vm.selectedPaymentType = p.id
                              },
                            },
                          }),
                        ]),
                      ])
                    }),
                  ],
                  2
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { class: _vm.$x.right },
              [
                _vm.selectedPaymentType == 54
                  ? _c("ns-sepa-form", {
                      ref: "sepaForm",
                      class: _vm.$x["credit-card-form"],
                      attrs: {
                        name: _vm.accountHolderName,
                        translations: _vm.t,
                        syle: "max-width: 500px",
                      },
                      model: {
                        value: _vm.formData.cardNumber,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "cardNumber", $$v)
                        },
                        expression: "formData.cardNumber",
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.selectedPaymentType == 98
                  ? _c("ns-cedyna-form", {
                      ref: "cedynaForm",
                      class: _vm.$x["credit-card-form"],
                      staticStyle: { "max-width": "500px" },
                      attrs: {
                        "payment-type-id": _vm.formData.paymentTypeId,
                        translations: _vm.t,
                        "available-payments": _vm.availableCedynaTypes,
                      },
                      model: {
                        value: _vm.formData,
                        callback: function ($$v) {
                          _vm.formData = $$v
                        },
                        expression: "formData",
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.isCreditCardPaymentType(_vm.selectedPaymentType)
                  ? _c("ns-credit-card-form", {
                      ref: "addCreditCardForm",
                      class: _vm.$x["credit-card-form"],
                      staticStyle: { "max-width": "500px" },
                      attrs: {
                        translations: _vm.t,
                        "available-payments": _vm.formCreditTypes,
                        "prevent-jcb-bin": true,
                      },
                      model: {
                        value: _vm.formData,
                        callback: function ($$v) {
                          _vm.formData = $$v
                        },
                        expression: "formData",
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.paymentTypeFormName(_vm.selectedPaymentType) ===
                "emptyPayment"
                  ? _c("div", { attrs: { id: "otherPaymentInfo" } }, [
                      _c("h2", { staticClass: "subtitle-medium-semibold" }, [
                        _vm._v(_vm._s(_vm.selectedPaymentTypeLocalizedName)),
                      ]),
                      _vm._v(" "),
                      _c("img", {
                        class: _vm.$x["p-icon-large"],
                        attrs: {
                          src: _vm.getCardIcon(_vm.selectedPaymentType),
                        },
                      }),
                      _vm._v(" "),
                      _c("p", {
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.sanitizeHTML(
                              _vm.paymentMethodsInfo(_vm.selectedPaymentType)
                            )
                          ),
                        },
                      }),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.withAddress
                  ? _c(
                      "div",
                      { class: _vm.$x["border-top"] },
                      [
                        _c("ns-address-form", {
                          ref: "addAddressForm",
                          attrs: {
                            lang: _vm.language,
                            translations: _vm.t.address,
                            editing: _vm.editingBillingAddress,
                          },
                          on: {
                            editing: _vm.setEditingBillingAddress,
                            "address-valid": _vm.setAddressFormValid,
                          },
                          model: {
                            value: _vm.addressFormData,
                            callback: function ($$v) {
                              _vm.addressFormData = $$v
                            },
                            expression: "addressFormData",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.editingBillingAddress,
                        expression: "!editingBillingAddress",
                      },
                    ],
                  },
                  [
                    _c(
                      "div",
                      { class: _vm.$x["border-top"] },
                      [
                        _c(
                          VForm,
                          { ref: "addPaymentCheckboxForm" },
                          [
                            _c(
                              VCheckbox,
                              {
                                attrs: {
                                  name: "agreeToSave",
                                  disabled: "",
                                  checked: "",
                                  color: "#7123D9",
                                },
                                model: {
                                  value: _vm.agreeToSave,
                                  callback: function ($$v) {
                                    _vm.agreeToSave = $$v
                                  },
                                  expression: "agreeToSave",
                                },
                              },
                              [
                                _c("template", { slot: "label" }, [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(_vm.t.agreeToSavePaymentType) +
                                      "\n                "
                                  ),
                                ]),
                              ],
                              2
                            ),
                            _vm._v(" "),
                            !_vm.hideDefaultCheckbox()
                              ? _c(
                                  VCheckbox,
                                  {
                                    attrs: {
                                      name: "setAsDefault",
                                      color: "#7123D9",
                                    },
                                    model: {
                                      value: _vm.setAsDefault,
                                      callback: function ($$v) {
                                        _vm.setAsDefault = $$v
                                      },
                                      expression: "setAsDefault",
                                    },
                                  },
                                  [
                                    _c("template", { slot: "label" }, [
                                      _vm._v(_vm._s(_vm.t.setAsDefault)),
                                    ]),
                                  ],
                                  2
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.enableStoredCredentials
                          ? _c(
                              "p",
                              { class: [_vm.$x["tac"], _vm.$x["message"]] },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.t.agreeToTermsOfUseMessage) +
                                    " "
                                ),
                                _c(
                                  "a",
                                  {
                                    class: [_vm.$x.lnk],
                                    attrs: {
                                      href: _vm.termsOfUseLnk,
                                      target: "_blank",
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.t.termsOfUse))]
                                ),
                              ]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { class: _vm.$x["border-top"] },
                      [
                        _c("ns-alert", {
                          class: [_vm.$x.alert, _vm.$x.mobile],
                          attrs: {
                            type: "card",
                            context: "error",
                            title: _vm.t.serverErrorTitle,
                            visible: _vm.showAddPaymentAlert,
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "body",
                              fn: function () {
                                return [
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.sanitizeHTML(
                                          _vm.t.serverErrorMessage
                                        )
                                      ),
                                    },
                                  }),
                                ]
                              },
                              proxy: true,
                            },
                          ]),
                        }),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "hit-solid fluid form-save",
                            attrs: {
                              name: "saveAddPayment",
                              disabled: _vm.savePaymentProcessing,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.doSavePayment(_vm.formData)
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.t.save))]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "hit-outline fluid",
                            attrs: { name: "cancelAddPayment" },
                            on: {
                              click: function ($event) {
                                return _vm.cleanupAddEditPayment()
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.t.cancel))]
                        ),
                      ],
                      1
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _c(
            VDialog,
            {
              attrs: { "content-class": "delete-confirmation" },
              model: {
                value: _vm.deleteConfirm,
                callback: function ($$v) {
                  _vm.deleteConfirm = $$v
                },
                expression: "deleteConfirm",
              },
            },
            [
              _c(
                VCard,
                [
                  _c(VCardTitle, { staticClass: "title-small-bold" }, [
                    _vm._v(_vm._s(_vm.t.confirmDeletePayment)),
                  ]),
                  _vm._v(" "),
                  _c(VCardActions, [
                    _c(
                      "button",
                      {
                        staticClass: "inverse-solid short",
                        attrs: { name: "cancelDelete" },
                        on: {
                          click: function ($event) {
                            _vm.deleteConfirm = false
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.t.cancel))]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "alert-solid short",
                        attrs: { name: "confirmDelete" },
                        on: {
                          click: function ($event) {
                            return _vm.doDeletePayment()
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.t.delete))]
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }